import React from 'react';
import history from 'config/history';

import { generateQueryString } from 'shared/utils/url';
import { buildUrlFromNextRedirect } from 'shared/utils/buildUrlFromNext';

import Button from 'shared/components/Button';

import {
  LINKEDIN_REDIRECT_URI,
  LINKEDIN_CLIENT_ID,
  LINKEDIN_STATE,
  LINKEDIN_URL
} from 'global-constants';

import styles from './styles.module.scss';

class LinkedInButton extends React.Component {
  linkedinLogIn = () => {
    const nextUrl =
      buildUrlFromNextRedirect(history.location.search) ||
      history.location.pathname;
    localStorage.setItem('nextUrl', nextUrl);
    let linkedInUrl = LINKEDIN_URL;
    let params = {
      response_type: 'code',
      client_id: LINKEDIN_CLIENT_ID,
      state: LINKEDIN_STATE,
      redirect_uri: LINKEDIN_REDIRECT_URI,
      scope: 'r_emailaddress,r_liteprofile'
    };

    window.location = `${linkedInUrl}?${generateQueryString(params)}`;
  };

  render() {
    return (
      <Button className={styles.linkedInBtn} onClick={this.linkedinLogIn}>
        {this.props.name}
      </Button>
    );
  }
}

export default LinkedInButton;
